import React, { useState, useEffect } from "react";
import { Card, Typography } from "@material-tailwind/react";
import Popup from "reactjs-popup";
import "../../../../styles/popup.css";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import API from "../../../../utils/API";
import CustomTable from "../../../DynamicComponents/CustomTable";
import CurrentLocationPopUp from "../PopUp/CurrentLocationPopUp";

const CurrentLocation = ({ setBlurActive }) => {
  const [locationData, setLocationData] = useState([]);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const user = useSelector((state) => state.auth.user) || {};
  const { user_id, department_id } = user;

  const fetchLocationData = async () => {
    try {
      const response = await API.get(
        `${department_id}/alumni/location?user_id=${user_id}`
      );
      const data = response?.data;
      if (data && data.length > 0) {
        setLocationData([
          {
            city: data.city,
            state: data.state,
            country: data.country,
            address: data.address,
          },
        ]);
      } else {
        setLocationData(null); // Explicitly set to null when no valid data
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.error || "Error communicating with server"
      );
    }
  };

  useEffect(() => {
    if (!user_id) return;
    fetchLocationData();
  }, [user_id]);

  const openPopup = () => {
    setPopupOpen(true);
    setBlurActive(true);
    setIsEditMode(!!locationData);
  };

  const closePopup = () => {
    setPopupOpen(false);
    setBlurActive(false);
    setIsEditMode(false);
  };

  const handleSaveLocation = async (newLocation) => {
    const { city, state, country, address } = newLocation;

    if (!city || !state || !country) {
      toast.error("Please fill all required fields");
      return;
    }

    try {
      const response = await API.post(
        `${department_id}/alumni/location`,
        newLocation,
        {
          params: { user_id },
        }
      );

      if (response?.data) {
        toast.success("Location details successfully saved");
        fetchLocationData();
        closePopup();
      }
    } catch (error) {
      toast.error(
        error.response?.data?.error ||
          "Error connecting to the server. Please try again."
      );
    }
  };

  const handleDeleteLocation = async () => {
    try {
      const response = await API.delete(`${department_id}/alumni/location`, {
        params: { user_id },
      });
      if (response?.data) {
        toast.success("Location details deleted successfully");
        setLocationData(null);
      }
    } catch (error) {
      toast.error(
        error.response?.data?.error || "Error deleting location details"
      );
    }
  };

  return (
    <>
      <CustomTable
        title="Current Location"
        subtitle="Your present location details"
        columns={[
          { key: "city", label: "City" },
          { key: "state", label: "State" },
          { key: "country", label: "Country" },
          { key: "address", label: "Address" },
          { key: "actions", label: "Actions" },
        ]}
        data={locationData || []}
        actions={{
          edit: () => openPopup(),
          delete: () => handleDeleteLocation(),
        }}
        onAdd={() => {
          setIsEditMode(false);
          openPopup();
        }}
      />

      <Popup
        open={isPopupOpen}
        onClose={closePopup}
        className="mx-auto my-auto p-2"
        closeOnDocumentClick
      >
        <div>
          <CurrentLocationPopUp
            city={locationData?.city || ""}
            state={locationData?.state || ""}
            country={locationData?.country || ""}
            address={locationData?.address || ""}
            closeModal={closePopup}
            handleSaveLocation={handleSaveLocation}
            isEditMode={isEditMode}
          />
        </div>
      </Popup>
    </>
  );
};

export default CurrentLocation;
